import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{staticClass:"mb-2 font-weight-regular",attrs:{"label":"Selecione o tipo de relatório","items":_vm.items,"item-text":"descricao","item-value":"id","return-object":"","hide-details":"","outlined":"","dense":""},model:{value:(_vm.RELATORIO_SELECIONADO_COMPUTED),callback:function ($$v) {_vm.RELATORIO_SELECIONADO_COMPUTED=$$v},expression:"RELATORIO_SELECIONADO_COMPUTED"}})
}
var staticRenderFns = []

export { render, staticRenderFns }